import { addAPIKeyToWorksheet, createDataSourceTables, createMemoryTable } from "../../../../../service/sourceServices";
import { ProcessedData } from "../../../store/types";

interface InitializeCicadaArgs {
  apiKey: string;
  data: ProcessedData;
}

const initializeCicada = async ({ apiKey, data }: InitializeCicadaArgs) => {
  await Excel.run(async (context) => {
    await addAPIKeyToWorksheet(context, apiKey);
    await context.sync();

    await createDataSourceTables({ context, data });
    await context.sync();

    await createMemoryTable(context);
    await context.sync();
  });
};

export default initializeCicada;
